import apiClient from './apiClient';

export const calendlyApi = {
  getStatus: async () => {
    const response = await apiClient.get('/calendly/status');
    return response.data;
  },

  connect: async (apiToken) => {
    const response = await apiClient.post('/calendly/connect', { apiToken });
    return response.data;
  },

  disconnect: async () => {
    const response = await apiClient.delete('/calendly/disconnect');
    return response.data;
  },

  getEventTypes: async () => {
    const response = await apiClient.get('/calendly/event-types');
    return response.data;
  },

  updateSettings: async (settings) => {
    const response = await apiClient.put('/calendly/settings', settings);
    return response.data;
  },

  createSchedulingLink: async (eventTypeUri) => {
    const response = await apiClient.post('/calendly/scheduling-link', { eventTypeUri });
    return response.data;
  },
};
